export default "__VITE_ASSET__DfmaGKRl__"